import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React from 'react';

import { useQueryParam } from '../hooks/useQueryParams';
import { createCommunityTheme } from '../theme';

interface DynamicThemeProviderProps {
  children: React.ReactNode;
}

export const DynamicThemeProvider: React.FC<DynamicThemeProviderProps> = ({
  children,
}) => {
  const specificTheme = useQueryParam('specific_theme') || 'true';

  const currentPath = window.location.pathname;
  const pathSegments = currentPath.split('/').filter(Boolean);
  // URL: /support/chatbot/lang/community/session_id
  const communityFromPath = pathSegments[3]; // the fourth segment is the community

  const theme =
    specificTheme === 'true' && communityFromPath
      ? createCommunityTheme(communityFromPath)
      : createCommunityTheme('default');

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
